<template>
  <div class="overview_wrapper">
    <Greeting />
    <div class="overview_sections">
      <template v-if="getUserType !== 'observer'">
        <SectionCard
          title="TOTAL PATIENTS"
          class="overview_section5 total-patients"
          sectionId="5"
        >
          <span class="total-patient-text">Total Patients</span>
          <h3 class="total_count_style_provider">{{ patientsTableDataForProvider.length }}</h3>
        </SectionCard>

        <SectionCard title="IMPORT ERRORS" class="overview_section3" sectionId="6">
          <div class="error-section">
            <div class="horizontal-line"></div>
            <div class="vertical-line"></div>
            <el-row class="import-section-1">
              <el-col :span="8" class="import-section-error-count">{{ getErrorCount('same_schedule') }}</el-col>
              <el-col :span="16" class="import-section-error-string">Multiple appointments</el-col>
            </el-row>
            <el-row class="import-section-2">
              <el-col :span="8" class="import-section-error-count">{{ getErrorCount('no_match') }}</el-col>
              <el-col :span="16" class="import-section-error-string">Missing appointment</el-col>
            </el-row>
            <el-row class="import-section-3">
              <el-col :span="8" class="import-section-error-count">{{ getErrorCount('invalid_provider') }}</el-col>
              <el-col :span="16" class="import-section-error-string">Missing<br>doctor</el-col>
            </el-row>
            <el-row class="import-section-4">
              <el-col :span="8" class="import-section-error-count">{{ getErrorCount('date') }}</el-col>
              <el-col :span="16" class="import-section-error-string">Missing date & time</el-col>
            </el-row>
          </div>
          <router-link to="/import/errors" class="goto-import-page-button" tag="button">
            Go to Import Errors <i class="el-icon-right"></i>
          </router-link>
        </SectionCard>

        <SectionCard title="UPCOMING APPOINTMENTS" class="overview_section4" sectionId="7">
          <el-row class="appointment-tabs">
            <el-col :span="8" @click.native="selectTab('today')" :class="['tab', activeTab === 'today' ? 'active-tab' : '']">Today</el-col>
            <el-col :span="8" @click.native="selectTab('tomorrow')" :class="['tab', activeTab === 'tomorrow' ? 'active-tab' : '']">Tomorrow</el-col>
            <el-col :span="8" @click.native="selectTab('next')" :class="['tab', activeTab === 'next' ? 'active-tab' : '']">Next 7 days</el-col>
          </el-row>
          <el-row class="appointment-data">
            <el-col :span="5" class="data">
              <div class="container">
                <span class="dot green"></span>
                <span class="count">{{ getAnsweredAllQuestionCount }}</span>
                <span class="text">answered all questionnaires</span>
              </div>
            </el-col>
            <el-col :span="5" class="data">
              <div class="container">
                <span class="dot orange"></span>
                <span class="count">{{ getAnsweredSomeQuestionCount }}</span>
                <span class="text">answered some questionnaires</span>
              </div>
            </el-col>
            <el-col :span="5" class="data">
              <div class="container">
                <span class="dot red"></span>
                <span class="count">{{ getAnsweredNoQuestionCount }}</span>
                <span class="text">answered no questionnaires</span>
              </div>
            </el-col>
            <el-col :span="9" class="buttons">
              <button class="appointment-remind-button">
                <span class="small-dot orange"></span> 
                <span class="small-dot red"></span>
                Remind {{ getAnsweredNoQuestionCount + getAnsweredSomeQuestionCount }} patients now
              </button>
              <button class="appointment-print-button">
                <span class="small-dot green"></span>
                <span class="small-dot orange"></span>
                Print {{ getAnsweredAllQuestionCount + getAnsweredSomeQuestionCount }} Face Sheets now
              </button>
            </el-col>
          </el-row>
        </SectionCard>
      </template>


      <template v-if="getUserType === 'observer'">
        <SectionCard
          title="TOTAL PATIENTS"
          class="overview_section1"
          sectionId="1"
          >
          <HalfChart :values="getGraphValues" />
          <h3 class="total_count_style">{{ totalPatients }}</h3>
        </SectionCard>
        <SectionCard title="PATIENT TAGS" v-if="getUserType === 'observer'" class="overview_section2" sectionId="2">
          <div class="patient_tag_wrapper">
            <div class="patient_tag_wrapper">
              <div v-for="tag in patientTags" :key="tag.tag">
                <div class="patient_tag_row">
                  <div class="patient_icon_row">
                    <DeviceTagIcon :color="getTagColor(tag.tag)" />
                    <p class="label_style">{{ getTagName(tag.tag) }}</p>
                  </div>
                  <p class="count_style">{{ tag.count }}</p>
                </div>
                <div class="patient_seperator"></div>
              </div>
            </div>
          </div>
        </SectionCard>
        <SectionCard title="ALL SITES" v-if="getUserType === 'observer'" class="overview_section2" sectionId="3">
          <div class="patient_tag_wrapper">
            <div v-for="site in allSites" :key="site.name">
              <div class="patient_tag_row">
                <div class="site_code_wrapper">
                  <p class="label_style">{{ site.name }}</p>
                  <p class="label_style">({{ site.code }})</p>
                </div>
                <p class="count_style">{{ site.count }}</p>
              </div>
              <div class="patient_seperator"></div>
            </div>
          </div>
        </SectionCard>
        <SectionCard title="APPOINTMENTS" v-if="getUserType === 'observer'" class="overview_section2" sectionId="4">
          <div class="patient_tag_wrapper">
            <div v-for="appointment in appointments" :key="appointment.label">
              <div class="patient_tag_row">
                <p class="label_style">{{ appointment.label }}</p>
                <p class="count_style">{{ appointment.value }}</p>
              </div>
              <div class="patient_seperator"></div>
            </div>
          </div>
        </SectionCard>
      </template>

    </div>
    <TableFilter @dataType="setDataType" />
    <DataTable :key="dataType" :dataType="dataType" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex"
import DeviceTagIcon from "@/module/component/DeviceTagIcon"

import Greeting from "./Greeting"
import SectionCard from "./SectionCard"
import HalfChart from "./HalfChart.vue"
import TableFilter from "./Table/Filter.vue"
import DataTable from "./Table/DataTable.vue"
import getTimeformat from "@/module/add/util/getTimeformat"

export default {
  name: "overview",
  data() {
    return {
      dataType: 'patient',
      activeTab: 'today'
    }
  },
  components: {
    Greeting,
    SectionCard,
    DeviceTagIcon,
    HalfChart,
    TableFilter,
    DataTable,
  },
  mounted() {
    if (this.getUserType === 'observer')
      this.getOverviewDataForSafe(this.getProviderList[0])
    else
      this.getOverviewDataForProvider(this.getProviderList[0])
  },
  methods: {
    ...mapActions("overview", ["getOverviewDataForSafe", "getOverviewDataForProvider"]),
    selectTab(tab) {
      this.activeTab = tab
    },
    setDataType(dataType) {
      this.dataType = dataType
    },
    getTagColor(tag) {
      let tagObj = this.getTagToColorMapping.filter((obj) => obj.id === tag);
      if (tagObj.length) return tagObj[0].color;
      else return "#000000";
    },
    getTagName(tag) {
      let tagObj = this.getTagToColorMapping.filter((obj) => obj.id === tag);
      if (tagObj.length) return tagObj[0].name;
      else return "";
    },
    getErrorCount(type) {
      let timedImportErrors = this.timedImportErrors
      if (timedImportErrors.length && timedImportErrors[0].list) {
        let errors = timedImportErrors[0].list
        return errors.filter(err => err.type === type).length
      }
      return 0
    },
  },
  computed: {
    ...mapGetters("overview", [
      "allSites",
      "appointments",
      "totalPatients",
      "patientsTableDataForProvider",
      "patientTags",
    ]),
    ...mapGetters(['getUserType']),
    ...mapGetters('provider', ['getTagToColorMapping', 'getProviderList', 'getAllProviderPatientList']),
    ...mapState('provider', ['importErrors', 'providerPatients']),
    getGraphValues() {
      const total = this.patientTags.reduce((acc, val) => acc + val.count, 0);
      const values = this.patientTags.map((tag) =>
        Math.floor((tag.count / total) * 180)
      );
      var count = 0;
      return values.map((val) => {
        var currentCount = count;
        count += val;
        return currentCount + val;
      });
    },
    timedImportErrors() {
      const errorTypeOrder = [
          ["multiple_matches", "same_schedule"],
          "invalid_provider",
          "date",
          "no_match",
          "name",
          "email",
          "phone"
      ]
      const typeNameMap = {
          same_schedule: "Multiple Appointments",
          multiple_matches: "Multiple Appointments",
          invalid_provider: "Missing Doctor",
          date: "Missing Date and Time",
          no_match: "Missing Appointment",
          name: "Missing Name",
          email: "Missing Email",
          phone: "Missing Phone"
      }
      return Object.values([...this.importErrors].reduce((acc, errObject) => {
          const err = errObject.data
          const timestamp = err.audit.split(":")[0]
          if (!acc[timestamp]) {
              acc[timestamp] = {
                  upload_timestamp: timestamp,
                  dateString: getTimeformat(parseInt(timestamp, 10)),
                  list: [
                      errObject
                  ]
              }
              return acc
          }
          acc[timestamp].list.push(errObject)
          return acc
      }, {})).sort((a, b) => b.upload_timestamp - a.upload_timestamp).map((obj, index) => {
          return {
              ...obj,
              list: obj.list.reduce((acc, err) => {
                  const problemTypes = err.data.problem.reduce((acc, problem) => {
                      if (problem.key.length > 0 && problem.status === "pending") {
                          [...problem.key].forEach(type => {
                              const str = type.split(":")
                              acc[0].push(str[0])
                              acc[1].push(str[1] || "")
                          })
                      }
                      return acc
                  }, [
                      [], // for prefix,
                      [] // for suffix
                  ])
                  for (let i = 0; i < errorTypeOrder.length; i++) {
                      let typeOrder = errorTypeOrder[i]
                      const isTypeArray = typeOrder instanceof Array
                      if (
                          isTypeArray ?
                          typeOrder.some((t) => problemTypes[0].includes(t)) :
                          problemTypes[0].includes(typeOrder)
                      ) {
                          let errorType = ""
                          if (isTypeArray) {
                              errorType = typeOrder.find(val => problemTypes[0].find((v) =>
                                  v === val))
                              typeOrder = errorType
                          } else {
                              const atIndex = problemTypes[0].indexOf(typeOrder)
                              errorType =
                                  `${typeOrder}${problemTypes[1][atIndex] ? `:${problemTypes[1][atIndex]}` : ""}`
                          }
                          if (acc[i]) {
                              acc[i].list.push({
                                  ...err,
                                  errorType,
                                  type: typeOrder
                              })
                          } else {
                              acc[i] = {
                                  displayName: typeNameMap[typeOrder],
                                  type: errorType,
                                  list: [{
                                      ...err,
                                      errorType,
                                      type: typeOrder
                                  }]
                              }
                          }
                      }
                  }
                  return acc
              }, []).filter(o => o !== null)
          }
      }).filter(el => el.list.length > 0)
    },
    getAllProviderPatientListScheduled() {
        return this.getAllProviderPatientList.filter(({ next_schedule }) =>  next_schedule)
    },
    providerwisePatientCountToday() {
        const patientList = this.getAllProviderPatientListScheduled.filter(({ next_schedule }) => (new Date()).toDateString() === (new Date(next_schedule)).toDateString())
        let providerwiseObj = {
            'total': patientList.length
        }
        if(this.getProviderList.length > 0)
            return this.providerPatients.reduce((providerAcc, provider) => {
                const patientCount = provider.patient.filter(({ next_schedule }) => (new Date()).toDateString() === (new Date(next_schedule)).toDateString()).length
                providerAcc[provider.id] = patientCount
                return providerAcc
            }, providerwiseObj)
        return {}
    },
    providerwisePatientCountTomorrow() {
        const tomorrow = new Date()
        tomorrow.setDate(tomorrow.getDate() + 1)
        const patientList = this.getAllProviderPatientListScheduled.filter(({ next_schedule }) => tomorrow.toDateString() === (new Date(next_schedule)).toDateString())
        let providerwiseObj = {
            'total': patientList.length
        }
        if(this.getProviderList.length > 0)
            return this.providerPatients.reduce((providerAcc, provider) => {
                const patientCount = provider.patient.filter(({ next_schedule }) => tomorrow.toDateString() === (new Date(next_schedule)).toDateString()).length
                providerAcc[provider.id] = patientCount
                return providerAcc
            }, providerwiseObj)
        return {}
    },
    providerwisePatientCountWeek() {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const nextWeek = new Date(today)
        nextWeek.setDate(nextWeek.getDate() + 7)
        const patientList = this.getAllProviderPatientListScheduled.filter(({ next_schedule }) => {
            const nextSchedule = new Date(next_schedule)
            return (today <= nextSchedule) && (nextWeek > nextSchedule)
        })
        let providerwiseObj = {
            'total': patientList.length
        }
        if(this.getProviderList.length > 0)
            return this.providerPatients.reduce((providerAcc, provider) => {
                const patientCount = provider.patient.filter(({ next_schedule }) => {
                    const nextSchedule = new Date(next_schedule)
                    return (today <= nextSchedule) && (nextWeek > nextSchedule)
                }).length
                providerAcc[provider.id] = patientCount
                return providerAcc
            }, providerwiseObj)
        return {}
    },
    getAnsweredAllQuestionCount() {
      return 0
    },
    getAnsweredSomeQuestionCount() {
      return 0
    },
    getAnsweredNoQuestionCount() {
      if (this.activeTab === 'today')
        return this.providerwisePatientCountToday['total']
      else if (this.activeTab === 'tomorrow')
        return this.providerwisePatientCountTomorrow['total']
      else if (this.activeTab === 'next')
        return this.providerwisePatientCountWeek['total']
    }
  },
};
</script>

<style scoped>
.overview_wrapper {
  background-color: #eee;
}

.overview_sections {
  display: flex;
  flex-wrap: wrap;
}

.overview_section1 {
  flex: 0.25;
}

.overview_section2 {
  flex: 0.3;
}

.overview_section3 {
  flex: 0.25;
}

.overview_section4 {
  flex: 0.53;
}

.overview_section4 >>> .el-card__body {
  padding: 0;
}

.overview_section5 {
  flex: 0.18;
}

.total-patients {
  position: relative;
}

.error-section {
  width: 100%;
  height: 120px;
  position: relative;
}
.horizontal-line {
  position: absolute;
  top: 40%;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #EEEEEE;
}

.vertical-line {
  top: 0;
  left: 50%;
  position: absolute;
  width: 2px;
  height: 80%;
  background-color: #EEEEEE;
}
.import-section-1 {
  position: absolute;
  top: 0;
  left: -10px;
  width: 50%;
  height: 60px;
}
.import-section-2 {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 60px;
}
.import-section-3 {
  position: absolute;
  top: 60px;
  left: -10px;
  width: 50%;
  height: 60px;
}
.import-section-4 {
  position: absolute;
  top: 60px;
  left: 50%;
  width: 50%;
  height: 60px;
}
.import-section-error-count {
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  color: #DA4E4E;
  padding: 10px 10px;
}
.import-section-error-string {
  font-weight: 400;
  font-size: 12px;
  line-height: 109.3%;
  color: #666666;
  padding: 5px 8px;
}

.goto-import-page-button {
    width: 90%;
    height: 35px;
    background-color: #ffffff;
    border: 1px solid #cccccc;
    outline: none;
    line-height: 35px;
    position: absolute;
    bottom: 10px;
    left: 5%;
    color: #333333;
    position: relative;
}
.el-icon-right {
  position: absolute;
  font-size: 16px;
  top: 10px;
  right: 56px;
}

.appointment-tabs {
  height: 41px;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: #333333;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.active-tab {
  color: #833E93;
  font-weight: 700;
  background-color: #FAF5FC;
}
.tab {
  height: 100%;
  display: flex;
	align-items: center;
	justify-content: center;
}

.appointment-data {
  margin: 25px 10px;
  height: 90px;
}

.appointment-data >>> .data {
  height: 100%;
  display: flex;
	align-items: center;
  justify-content: center;
  border-right: 1px solid #eeeeee;
}
.appointment-data >>> .container {
    margin-left: 25%;
}
.dot {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-right: 5px;
}
.green {
  background-color: #44B358;
}
.orange {
  background-color: #FA9E25;
}
.red {
  background-color: #DA4E4E;
}
.appointment-data >>> .count {
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: #333333;
}
.appointment-data >>> .text {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #666666;
  display: block;
  margin-top: 5px;
}
.buttons {
  height: 100%;
  display: flex;
	align-items: center;
  justify-content: center;
  flex-direction: column;
}
.small-dot {
  border-radius: 50%;
  width: 5px;
  height: 5px;
  display: inline-block;
  margin-right: 3px;
}
.appointment-remind-button {
  width: 195px;
  height: 33px;
  border: 1px solid #CCCCCC;
  background: #FFFFFF;
  box-sizing: border-box;
  border-radius: 2px;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  color: #333333;
}
.appointment-print-button {
  width: 195px;
  height: 33px;
  background: #E2E2E2;
  border-radius: 2px;
  border: none;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  color: #333333;
  margin-top: 10px;
}

.patient_tag_wrapper {
  display: flex;
  flex-direction: column;
  min-height: 120px;
}

.patient_seperator {
  border: 1px solid #eeeeee;
  margin: 0.8rem 0;
}

.patient_tag_row {
  display: flex;
  justify-content: space-between;
}

.patient_icon_row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.count_style {
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  color: #525252;
}
.total_style {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;

  color: #828282;
}

.total_count_style {
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  color: #333333;
  text-align: center;
}

.total-patient-text {
  position: absolute;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #828282;
  top: 30%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.total_count_style_provider {
  position: absolute;
  font-weight: 600;
  font-size: 64px;
  line-height: 64px;
  color: #3572B9;
  top: 38%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.content_wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 150px;
}

.label_style {
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: #333333;
}

.site_code_wrapper {
  display: flex;
  gap: 5px;
}
</style>
